import { Injectable, Injector } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";

import { PerspectiveService } from "./perspective.service";

// see https://angular.io/guide/http#intercepting-all-requests-or-responses
// this interceptor appends the active introducer ID to the query string of any request - only relevent for internal staff users.

@Injectable()
export class PerspectiveInterceptor implements HttpInterceptor {
    constructor(private perspectiveService: PerspectiveService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const activeIntroducerID = this.perspectiveService.getActiveIntroducerID();

        if (activeIntroducerID) {
            const reqWithParam = req.clone({ params: req.params.set("activeIntroducerID", this.perspectiveService.getActiveIntroducerID()) })
            return next.handle(reqWithParam);
        } else {
            return next.handle(req);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/perspective/perspective.interceptor.ts